import React from "react";
import { Trash2 } from "lucide-react";

const PreviewTab = ({ theme, language, rows, onEditCell, onDeleteRow }) => {
  const isAr = language === "ar";

  if (!rows || rows.length === 0) {
    return (
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          color: theme === "dark" ? "rgba(255,255,255,0.4)" : "#9ca3af",
          fontSize: "14px",
        }}
      >
        {isAr ? "لا توجد بيانات للمعاينة" : "No data to preview"}
      </div>
    );
  }

  const headers = Object.keys(rows[0]);

  const thStyle = {
    padding: "10px 12px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    textAlign: "center",
    whiteSpace: "nowrap",
    background:
      theme === "dark"
        ? "linear-gradient(135deg, rgba(55,65,81,0.9), rgba(75,85,99,0.9))"
        : "linear-gradient(135deg, rgba(248,250,252,0.95), rgba(241,245,249,0.95))",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    borderBottom:
      theme === "dark"
        ? "2px solid rgba(59,130,246,0.3)"
        : "2px solid rgba(59,130,246,0.15)",
    position: "sticky",
    top: 0,
    zIndex: 5,
    backdropFilter: "blur(8px)",
  };

  const tdStyle = {
    padding: "8px 10px",
    fontSize: "12px",
    textAlign: "center",
    color: theme === "dark" ? "rgba(255,255,255,0.8)" : "#374151",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.06)"
        : "1px solid rgba(0,0,0,0.05)",
  };

  const inputStyle = {
    width: "100%",
    padding: "4px 8px",
    borderRadius: "6px",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.15)",
    background:
      theme === "dark" ? "rgba(30,41,59,0.8)" : "rgba(255,255,255,0.9)",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    fontSize: "12px",
    outline: "none",
    textAlign: "center",
    minWidth: "80px",
  };

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af",
          marginBottom: "12px",
        }}
      >
        {isAr
          ? `${rows.length} صف جاهز للاستيراد. يمكنك تعديل الخلايا أو حذف الصفوف قبل الاستيراد.`
          : `${rows.length} row(s) ready to import. Edit cells or delete rows before proceeding.`}
      </p>
      <div style={{ overflowX: "auto", borderRadius: "10px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            minWidth: `${headers.length * 110 + 60}px`,
          }}
        >
          <thead>
            <tr>
              <th style={{ ...thStyle, width: "40px" }}>#</th>
              {headers.map((h) => (
                <th key={h} style={thStyle}>
                  {h}
                </th>
              ))}
              <th style={{ ...thStyle, width: "40px" }}>
                {isAr ? "حذف" : "Del"}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr
                key={rowIdx}
                style={{ transition: "background 0.2s" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background =
                    theme === "dark"
                      ? "rgba(59,130,246,0.07)"
                      : "rgba(59,130,246,0.03)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              >
                <td
                  style={{
                    ...tdStyle,
                    color:
                      theme === "dark"
                        ? "rgba(255,255,255,0.35)"
                        : "#d1d5db",
                    fontSize: "11px",
                    fontWeight: "600",
                  }}
                >
                  {rowIdx + 1}
                </td>
                {headers.map((h) => (
                  <td key={h} style={tdStyle}>
                    <input
                      style={inputStyle}
                      value={row[h] ?? ""}
                      onChange={(e) => onEditCell(rowIdx, h, e.target.value)}
                    />
                  </td>
                ))}
                <td style={tdStyle}>
                  <button
                    onClick={() => onDeleteRow(rowIdx)}
                    title={isAr ? "حذف الصف" : "Delete row"}
                    style={{
                      padding: "4px 8px",
                      borderRadius: "6px",
                      border: "none",
                      background:
                        theme === "dark"
                          ? "rgba(239,68,68,0.2)"
                          : "rgba(254,226,226,0.8)",
                      color: theme === "dark" ? "#fca5a5" : "#dc2626",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Trash2 size={13} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviewTab;